module.exports = __webpack_public_path__ + "front/img/top.7318010d.png";